var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"no-body":""}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('b-row',[_c('b-col',{attrs:{"sm":"12","lg":"6"}},[_c('p',{staticClass:"h3"},[_vm._v("Liste des articles")])])],1)],1),_c('b-row',{staticClass:"p-4"},[_c('b-col',[_c('ItemsList',{attrs:{"category":_vm.category,"disabled":true}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }